<template>
  <div class="pa-10">
    <v-layout row wrap>

      <v-flex xs12>
        <v-alert 
          v-model="alert"
          type="warning" 
          dismissible>
          {{messageAlert}}
        </v-alert>
      </v-flex>

      <v-flex xs12 sm12 lg5 md5>
        <ListOccurrences 
          ref="listOccurrences" 
          :class="classListaOcorrencia" 
          :doctor="true" 
          v-on:regulation="callObj = $event" >
        </ListOccurrences>
      </v-flex>

      <v-flex xs12 sm12 lg7 md7>
        <v-card
          class="mt-xs-8 mt-sm-5 mt-lg-0 mt-md-0 ml-lg-4 ml-md-4"
          :style="$vuetify.breakpoint.name == 'xs'?'margin-top:16px':''"
          :height="$vuetify.breakpoint.name == 'sm' || $vuetify.breakpoint.name == 'xs' ?'800':'650'">
          <v-tabs
            v-model="currentItem"
            class="elevation-2 mb-0"
            color="teal accent-3"
            style="height:100%;"
            grow>
            <v-tab 
              :href="`#tab-avaliacao`" 
              :disabled="disabledTabAttendence">
              Atendimento
            </v-tab>
            <v-tab 
              :href="`#tab-encerramento`"
              :disabled="disabledTabFinishing">
              Encerramento
            </v-tab>
            <v-tabs-items 
              class="pb-0" 
              v-model="currentItem" 
              :style="$vuetify.breakpoint.name == 'sm' || $vuetify.breakpoint.name ==  'xs' ? ' height:93%' : 'height:90%'">
              <v-tab-item
                class="py-0"
                style="height:110%;background-color:transparent;"
                :value="'tab-avaliacao'">
                <StepEvaluation 
                  :callObj="callObj"  
                  ref="stepEvaluation" />
              </v-tab-item>

              <v-tab-item
                class="py-0"
                style="height:110%;background-color:transparent;"
                :value="'tab-encerramento'">
                <StepFinishing ref="stepFinishing"/>
              </v-tab-item>
            </v-tabs-items>
          </v-tabs>

          <v-card class="mt-2 text-right">
            <v-container class="px-5">
              <v-btn
                class="body-2 white--text mr-5"
                @click="previousStep"
                color="primary"
                v-if="currentItem !== 'tab-avaliacao'"
                depressed
                width="120">
                <v-icon>arrow_back</v-icon>Voltar
              </v-btn>
              <v-btn
                v-if="currentItem==='tab-encerramento'"
                color="primary"
                :success="success"
                :loading="loading"
                @click="sendRegulation">
                Enviar
              </v-btn>
              <v-btn
                v-else
                class="body-2 white--text"
                @click="nextStep"
                color="primary"
                depressed
                width="120">
                <!--TODO: chamar api aqui: PUT Update attendance 
                url: /api/regulatory-physician/attendances/:id
                {
    evaluation: string,
    proven_risk: string,
    consciousness_state: string,
    vehicle_type: string
}

fazer chamada da api aqui
                -->
                Seguir
                <v-icon>arrow_forward</v-icon>
              </v-btn>
            </v-container>
          </v-card>
        </v-card>
      </v-flex>
    </v-layout>
    
  </div>
</template>

<script>
import { mask } from "vue-the-mask";



import ListOccurrences from "../../components/shared/ListOccurrences";
import StepEvaluation from "../../components/shared/StepEvaluation";
import StepFinishing from '../../components/shared/StepFinishing'
var moment = require("moment");

export default {
  name: "DoctorCalls",
  directives: {
    mask
  },
  components: {
    
    ListOccurrences,
    StepEvaluation,
    StepFinishing
  },

  data: () => ({
    //=======================
    patient: "",
    alert:false,
    messageAlert:"",
    fab: false,
    disabledTabSolicitation: false,
    disabledTabPatient: true,
    disabledTabAttendence: true,
    disabledTabFinishing: true,
    message: "",
    success: false,
    loading: false,
    classListaOcorrencia: "pulseOff",
    selectedCall: undefined,
    codeCall: undefined,
    currentItem: "tab-avaliacao",
  }),
  mounted() {
    //TODO jackson : pra que serve essa recuperação aqui??
    this.$store.dispatch("loadAttendances");
    var channel = this.$pusher.subscribe("my-channel");
    channel.bind("my-event", () => {
      console.log("Ouviu o pusher");
      this.$store.dispatch("loadAttendances");
      this.classListaOcorrencia = "pulseOn";
      setTimeout(() => {
        this.classListaOcorrencia = "pulseOff";
      }, 4000);
    });
  },
  
  computed: {

    user () {
      return this.$store.getters.user;
    },

    callObj () {
      let call = this.$store.getters.call;
      return call;
    },

    callSeleted () {
      let call  = this.$store.getters.callSeleted;
      console.log('call Selected = ', call);
      return call;
    },

  },
  watch: {
    user () {
      var value = this.user;
      if (!value) {
        this.$router.push("/");
      }
    },
    sockets () {}
  },

  methods: {

    showAlert (message) {
      this.messageAlert = message
      this.alert = true
    },

    load () {
      return this.attendances;
    },

    async nextStep () {

      if ( this.$refs.stepEvaluation && this.$refs.stepEvaluation.isValid ){
        
        let updated = this.$refs.stepEvaluation.fixaSelected;
        let tarmUpdate = {
          id: updated.id,
          evaluation: updated.evaluation,
          proven_risk: updated.proven_risk,
          consciousness_state: updated.consciousness_state,
          vehicle_type: updated.vehicle_type,
        }
        let alterou = await this.$store.dispatch("editTarm",tarmUpdate)
          .then( async response => {
            let load = await this.$store.dispatch("loadAttendances");
            return response;
          })
          .catch( e => {
            return e;
          });
        if (alterou.status){
          this.$nextTick(() => {
            switch (this.currentItem) {
              case "tab-avaliacao":
                this.currentItem = "tab-encerramento";
                this.disabledTabAttendence = true;
                this.disabledTabFinishing = false;
                break;
            }
          });  
        }
      }
    },

    previousStep () {

      this.$nextTick(() => {
        switch (this.currentItem) {
          case "tab-encerramento":
            this.currentItem = "tab-avaliacao";
            this.disabledTabAttendence = false;
            this.disabledTabFinishing = true;
            break;
        }
      });
    },

    logOut () {
      this.$store.dispatch("logOut");
    },

    clearAttendance () {
      this.success = false
      this.currentItem = "tab-solicitacao";
      this.disabledTabSolicitation = false;
      this.disabledTabPatient = true;
      this.disabledTabAttendence = true;
      this.disabledTabFinishing = true;
      this.$refs.stepSolicitation.clearStep()
      this.$refs.stepPatients.clearStep()
      this.$refs.stepEvaluation.clearStep()
      this.$refs.stepFinishing.clearStep()
      this.$refs.listOccurrences.clearAttendance()
    },

    reset () {
      this.success = false;
      /* setTimeout(() => {
          window.location.reload();
        }, 1000); */
    },

    async sendRegulation () {
      /* let tarm = {
        code: this.codeCall,
        name: this.nome,
        phone: this.telefone,
        device: "desktop",
        reason: this.reason,
        status: 1,
        location: this.location,
        victms: this.pacientes,
        classifications: {
          type: "",
          reason: "",
          messagae: "",
          reference: ""
        }
      }; */
      if(this.$refs.stepFinishing.setFinishingInfoCall()){
        this.loading = true
        let update  = await this.$store.dispatch("updateSelectedCall")
          .then( async response => {
            this.success = true;
            let load = await this.$store.dispatch("loadAttendances");
            this.loading = false;
            this.clearAttendance();
          })
          .catch( error => {
            this.loading = false;
            console.log('teve algum erro',error)
          });
      }
    }
  }
};
</script>

<style scoped>
.not-uppercase {
  text-transform: none;
}
.chat-window {
  height: calc(70% - 320px);
}

.pulseOn {
  animation: pulseOn 5s infinite;
}
.pulseOff {
  animation: none;
}

@keyframes pulseOn {
  0% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(204, 0, 0, 0.8);
  }

  70% {
    transform: scale(1);
    box-shadow: 0 0 0 20px rgba(204, 0, 0, 0);
  }

  100% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(2204, 0, 0, 0);
  }
}
</style>